import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { MasterActions } from "@MasterBluePrint/Store/MasterState";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<{ isUsingBillingAddress: boolean }, DispatchProp<MasterActions>>;

export const DispatchSetIsUsingBillingAddress: HandlerType = props => {
    props.dispatch({
        type: "Pages/CheckoutShipping/SetIsUsingBillingAddress",
        isUsingBillingAddress: props.parameter.isUsingBillingAddress,
    });
};

export const chain = [DispatchSetIsUsingBillingAddress];

const setIsUsingBillingAddress = createHandlerChainRunner(chain, "SetIsUsingBillingAddress");
export default setIsUsingBillingAddress;
